import React from 'react';
import { CountdownTimer } from './Countdown';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
export function FinalCta() {
  return <section aria-labelledby="final-cta-title" className="w-full bg-brand-dark px-4 py-8 sm:px-6" data-id="element-76" data-mp="vhiw03u93ibh">
      <div className="mx-auto max-w-3xl text-center" data-id="element-77" data-mp="19cmcaewmxvf3">
        <span className="inline-block rounded-full bg-urgent px-3 py-1 font-head text-[10px] font-semibold uppercase tracking-wider text-white sm:text-xs" data-id="element-78" data-mp="15ckist1208aw">
          Limited-Time Offer
        </span>
        <h2 id="final-cta-title" className="mt-1 font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-79" data-mp="1ed8x7oud0aob">
          Complete your professional coaching system today
        </h2>

        <CountdownTimer data-id="element-80" data-mp="1o4n26c52y2ou" />

        <div className="mt-4 rounded-xl bg-white p-4" data-id="element-81" data-mp="223mgoqyvp17a">
          <h3 className="font-display text-2xl uppercase leading-none text-charcoal sm:text-3xl" data-id="element-82" data-mp="2245ze9wcrtmd">
            Padel Coach Pro™
          </h3>
          <p className="mt-1 text-xs text-softgray sm:text-[13px]" data-id="element-83" data-mp="n5m724f1y82x">
            Complete 6-in-1 Box Set + 5 Strategic Bonuses
          </p>
          <p className="mt-1.5 text-[13px] text-softgray" data-id="element-84" data-mp="s5qmrs84yys3">
            Regular Price: <span className="line-through" data-id="element-85" data-mp="x38zzut6s05w">$97</span>
          </p>
          <p className="font-display text-5xl leading-none text-urgent sm:text-6xl" data-id="element-86" data-mp="x5v7xvjzohon">TODAY: $27</p>
          <span className="mt-1 inline-block rounded-full bg-urgent px-3 py-1 font-head text-[11px] font-semibold uppercase tracking-wide text-white" data-id="element-87" data-mp="120sdutlz2axb">
            Save $70
          </span>

          <div className="mt-3 flex flex-col items-center" data-id="element-88" data-mp="1b1qm5o3g14lp">
            <CtaButton data-id="element-89" data-mp="1fu07srxizii6" />
            <TrustRow className="mt-2" accessLabel="Instant Digital Access" data-id="element-90" data-mp="1fus0nuzqn24r" />
          </div>
        </div>
      </div>
    </section>;
}